import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledLogsPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledLogsPageContentFlex = styled(Flex)`
    margin: 0 auto;
    padding-top: 32px;
    width: 100%;

    ${integrationMaxWidth}
`;
